import { useEffect, useState } from "react";

import { useWindowSize } from "@newsela/angelou";

const useDisplaySideBar = () => {
  const { width } = useWindowSize();
  const [displaySidebar, setDisplaySideBar] = useState(true);
  const MINIMUM_WIDTH_FOR_SIDEBAR = 840;

  useEffect(() => {
    width <= MINIMUM_WIDTH_FOR_SIDEBAR
      ? setDisplaySideBar(false)
      : setDisplaySideBar(true);
  }, [width]);

  return displaySidebar;
};

export default useDisplaySideBar;
